<template>
  <v-container
    class="px-8"
    >
    <v-row class="border mt-6">
      <v-col 
        class="px-4"
        cols="6">
        <span 
          class="text-h5 font-weight-medium">
          {{ $t('contract.show.main_panel.headers.payments')}}
        </span>
      </v-col>
      <v-col 
        class="pr-4"
        cols="6">
        <div
          class="d-flex flex-row align-center justify-end"
          >
          <v-btn
            @click="$router.push({name: 'CreateUserTax', id: $route.params.id, query: { objectType: 'User' }})"
            color="primary"
            >
            {{ $t('action.add_tax') }}
          </v-btn>
        </div>
      </v-col>
      <v-col
        cols="12"
        class="pt-0 px-4"
        v-if="taxes.length"
        v-for="tax in taxes"
        >
        <tax
          :tax="tax"
          @reload="fetchTaxes"
          ></tax>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { UserTaxes } from '@/graphql/queries/directory'

import Tax from '@/components/taxes/Tax'

export default {
  data: () => ({
    taxes: []
  }),

  created () {
    this.fetchTaxes ()
  },

  methods: {
    fetchTaxes () {
      this.$apollo.query({
        query: UserTaxes,
        variables: {
          id: this.$route.params.id
        },
        fetchPolicy: 'no-cache'
      }).then ( res => {
        console.log(res)
        this.taxes = res.data.userTaxes
      })
    }
  },

  components: { Tax } 
}
</script>
